// Model.js
// -----------------------
// @module Case
define('ShippingMessage.Model', [
    'Backbone',
    'Utils'
], function ShippingMessageModel(
    Backbone,
    Utils
) {
    'use strict';

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        // @property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath('services/ShippingMessage.Service.ss')
        )
    });
});
